import { render, staticRenderFns } from "./bszn.vue?vue&type=template&id=7fc6f475&scoped=true"
import script from "./bszn.vue?vue&type=script&lang=js"
export * from "./bszn.vue?vue&type=script&lang=js"
import style0 from "./bszn.vue?vue&type=style&index=0&id=7fc6f475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6f475",
  null
  
)

export default component.exports